// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { TypeFilterObject } from "@hex-insights/core";

export type StandardFilterFormValues = {};

export const initialStandardFilters: StandardFilterFormValues = {};

export const standardFiltersTypeFilterObject: TypeFilterObject<StandardFilterFormValues> = {};
